import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Sparkles, Leaf, ExternalLink } from "lucide-react";
import { http, formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const ModuleBuddy = ({ courseId, it }) => {
  const [open, setOpen] = useState(false);
  const [h, setH] = useState(null);
  const ask = async () => {
    setOpen(true);
    if (h) return;
    try { setH((await http.post("/canvas-modules/me/help", { course_id: courseId, item_id: it.id })).data); }
    catch (e) { toast.error(formatApiError(e)); setOpen(false); }
  };
  return (
    <>
      <button onClick={ask} data-testid={`module-item-buddy-${it.id}`} className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-[#F7EFE3] text-[#9A4F1C] text-xs hover:bg-[#F1E2CC] transition-colors whitespace-nowrap"><Sparkles className="w-3 h-3" />Ask Buddy</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#FDFBF7] max-w-md" data-testid={`module-buddy-dialog-${it.id}`}>
          <DialogHeader><DialogTitle className="font-display text-2xl text-[#2C4A3E]">{it.title}</DialogTitle>
            <DialogDescription className="text-stone-500">Buddy explains it. You do the thinking!</DialogDescription></DialogHeader>
          {!h ? <p className="text-sm text-stone-500 animate-pulse" data-testid="module-buddy-loading">Buddy is reading this for you…</p> : (
            <div className="space-y-4 text-sm text-[#1F3D33]">
              <p data-testid="module-buddy-explain">{h.explain}</p>
              {h.steps?.length > 0 && <ol className="list-decimal pl-5 space-y-1" data-testid="module-buddy-steps">{h.steps.map((s, k) => <li key={k}>{s}</li>)}</ol>}
              {h.calm && <p className="flex gap-2 rounded-xl bg-[#EEF4EF] px-3 py-2 text-[#2E5A45]" data-testid="module-buddy-calm"><Leaf className="w-4 h-4 shrink-0 mt-0.5" />{h.calm}</p>}
              <div className="flex flex-wrap gap-2 pt-1">
                <Link to={`/learn/${h.subject_id}?topic=${encodeURIComponent(h.topic)}`} data-testid="module-buddy-practice" className="px-4 py-2 rounded-full bg-[#2C4A3E] text-white text-sm hover:bg-[#1F3D33] transition-colors">Practice: {h.topic}</Link>
                {it.url && <a href={it.url} target="_blank" rel="noreferrer" data-testid="module-buddy-open" className="inline-flex items-center gap-1 px-4 py-2 rounded-full border border-[#D6CDB4] text-sm text-[#2C4A3E]">Open in Canvas <ExternalLink className="w-3.5 h-3.5" /></a>}
              </div>
            </div>)}
        </DialogContent>
      </Dialog>
    </>
  );
};
